import { apiFetch, parseErrorDetail, ApiError } from "@/api/fetch";

export interface ApiKeyRow {
  id: string;
  key_prefix: string;
  name: string;
  scopes: string[];
  enabled: boolean;
  created_at: string;
}

export interface ApiKeyCreateBody {
  name: string;
  scopes: string[];
}

export { ApiError as ApiKeysRequestError };

export const listApiKeys = async (): Promise<ApiKeyRow[]> => {
  const response = await apiFetch("/api-keys/");
  if (!response.ok) {
    throw new ApiError(await parseErrorDetail(response), response.status);
  }
  return response.json() as Promise<ApiKeyRow[]>;
};

export type ApiKeySecretResult = { row: ApiKeyRow; rawKey: string };

export const createApiKey = async (
  body: ApiKeyCreateBody,
): Promise<ApiKeySecretResult> => {
  const response = await apiFetch("/api-keys/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    throw new ApiError(await parseErrorDetail(response), response.status);
  }
  const row = (await response.json()) as ApiKeyRow;
  const rawKey = response.headers.get("x-api-key") ?? "";
  if (!rawKey) {
    throw new ApiError("Server did not return X-Api-Key header", 500);
  }
  return { row, rawKey };
};

export const deleteApiKey = async (id: string): Promise<void> => {
  const response = await apiFetch(`/api-keys/${encodeURIComponent(id)}`, {
    method: "DELETE",
  });
  if (response.status === 204 || response.status === 404) return;
  if (!response.ok) {
    throw new ApiError(await parseErrorDetail(response), response.status);
  }
};

export const rotateApiKey = async (id: string): Promise<ApiKeySecretResult> => {
  const response = await apiFetch(`/api-keys/${encodeURIComponent(id)}/rotate`, {
    method: "POST",
  });
  if (!response.ok) {
    throw new ApiError(await parseErrorDetail(response), response.status);
  }
  const row = (await response.json()) as ApiKeyRow;
  const rawKey = response.headers.get("x-api-key") ?? "";
  if (!rawKey) {
    throw new ApiError("Server did not return X-Api-Key header", 500);
  }
  return { row, rawKey };
};
